import React from 'react'
import { Link } from "react-router-dom"
import { TxtLink } from 'atoms/Texts'
import Icon from 'atoms/Icon'

export const actionFormatter = (cell, row, rowIndex, formatExtraData) => {
  const { edit, del, detailUrl, allowEdit, allowDel, detailBtn, style, isContractor = false } = formatExtraData
  const isValidated = !!row.validatedAt
  const hideEditDelete = isContractor && isValidated 
  return (
    <div style={style}>
      {allowEdit && 
        <TxtLink weight={'bold'} href={'#'} onClick={edit(row)}>
          Edit
        </TxtLink>
      }
      {detailBtn && 
        <Link to={detailUrl(row)} style={{ textDecoration: 'none' }}>
          <TxtLink weight={'bold'} showPointer>
            Detail
          </TxtLink>
        </Link>
      }
      {allowDel && 
        <Icon icon={'trash-alt'} ml={'15%'} color={'red'} onClick={del(row, rowIndex)} showPointer={true} />
      }
    </div>
  )
}
